import type { CrawlerEvidenceRowResponse } from '@prerender/diagnostics-api';

import { ABSENT_VALUE } from './formatMeasuredValue';

export const MINUS_SIGN = '−';

export function formatRequestCount(count: number): string {
  return Math.round(count).toLocaleString('en-US');
}

export function formatRequestCountOrAbsent(count: number | null | undefined): string {
  return count == null ? ABSENT_VALUE : formatRequestCount(count);
}

export function formatDropAsChange(dropPercent: number): string {
  return `${MINUS_SIGN}${dropPercent}%`;
}

export function spansSeveralDomains({ affectedDomainCount }: CrawlerEvidenceRowResponse): boolean {
  return affectedDomainCount > 1;
}

export function worstDomainLabel(worstMetricValue: number, worstDomain: string): string {
  return `up to ${formatDropAsChange(worstMetricValue)} on ${worstDomain}`;
}

export function affectedDomainsLabel(count: number): string {
  return `${count} ${count === 1 ? 'domain' : 'domains'}`;
}
